import { createInactivityTracker } from '@execonline-inc/inactivity-tracking.private';
import { saveApplicationLocation } from '@execonline-inc/navigation.private';
import { currentUserStore } from '../CurrentUserStore';
import { MessageBus } from '../MessageBus';

export const InactivityLogoutTracker = createInactivityTracker({
  name: 'user-activity',
  onTimeout: () => {
    const onFork = () => currentUserStore.logout();
    saveApplicationLocation(window.location).fork(onFork, onFork);
  },
  onLocalActivity: (event, expiration) => {
    MessageBus.broadcast({ kind: 'user-activity', event, expiration: expiration.valueOf() });
  },
});
